import React from 'react';
import { Web3Provider } from './contexts/Web3Context';
import PresaleWidget from './components/PresaleWidget';
import './App.css';

function App() {
  // const [showAdmin, setShowAdmin] = useState(false);

  return (
    <Web3Provider>
      <div className="App">
        <header className="App-header">
          <h1>{process.env.REACT_APP_TOKEN_NAME || 'PRE'} Token Presale</h1>
          <p>{process.env.REACT_APP_PRESALE_DESCRIPTION || 'Buy SXPAUG tokens with BNB on BNB Smart Chain'}</p>
        </header>
        <main>
          <PresaleWidget />
        </main>
      </div>
    </Web3Provider>
  );
}

export default App;
